import { makeAjax, url } from "../helpers/global_helper";
import { getSocialMediaFingerPrint } from "./SocialMediaFingerPrint";

export const UpdateSocialMediaPlayerCount = (social_media_platform) => {
    
    const updateSocialMediaCount = async () => {
        if (!social_media_platform) return;
        try {
            const device_finger_print = await getSocialMediaFingerPrint();
            const device_type = localStorage.getItem("device_type");
            await makeAjax(url.USER_API.updateSocialMediaCount, { social_media_platform, device_finger_print, device_type }, url.USER_MS_EXT);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    updateSocialMediaCount();
};